// DONT DELETE -- good
import LoadingScreen from "./components/ui/loadingScreen";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import PixelProvider from './components/PixelProvider'; // Add this import

import { useEffect, useState, useCallback } from "react"; // Added useCallback
import {BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/homepage";
import Login from "./pages/main/LoginPage";
import ChatWindow from "./components/chatWindow";
import PreviewHomePage from "./pages/main/PreviewHomepage";

import Settings from "./components/settings/Settings";
import HelpSupport from "./pages/main/HelpSupport";
import DropdownMenu from "./components/auxiliary/DropdownMenu";
import UpgradeToPro from "./pages/main/UpgradeToPro";
import ChatHistoryViewer from "./pages/main/ChatHistoryViewer";
import AboutUs from "./pages/main/AboutUsPage";
import PowerRankings from "./seo-pages/resources/NFL/2025/week1/PowerRankings";
// TODO: Needs more development before production
// import PredictionAnalytics from "./components/analytics/predictionAnalytics/PredictionAnalytics";
import MarketAnalytics from "./components/analytics/marketAnalytics/MarketAnalytics";

import SportsHub from "./components/dashboards/SportsHub"; // Import the new MMA Fights component
// import FootballDash from "./components/dashboards/components/FootballDash"; // Import the new MMA Fights component
import FootballDashboard from "./pages/sport-dashboards/football/footballDashboard"; // Football dashboard component
import NBADashboard from "./pages/sport-dashboards/NBA/nbaDashboard";
import { BaseballDashRefactored } from "./pages/sport-dashboards/baseball"; // Import the new refactored baseball dashboard
import F1Dash from "./pages/sport-dashboards/F1/F1Dash"; // F1 dashboard component

import SettlementViewer from "./components/analytics/settlementService/manualSettlementForPredictions/SettlementViewer"; // Settlement viewer
import PredictionAccuracyDashboard from "./components/analytics/settlementService/manualSettlementForPredictions/PredictionAccuracyDashboard"; // Prediction accuracy
import PickstarPredictionsViewer from "./components/analytics/settlementService/manualSettlementForPredictions/PickstarPredictionsViewer"; // PickStar predictions
import PickstarPerformance from "./components/analytics/settlementService/manualSettlementForPredictions/PickstarPerformance"; // PickStar performance analysis


import TermsAndConditions from "./pages/legal/terms-and-conditions";
import Pricing from "./pages/legal/pricing";
import Privacy from "./pages/legal/privacy";
import FAQ from "./pages/legal/faq";

import { ChatProvider } from './components/chat/chatContext';

// Various utils
import TestContainer from './components/tests/TestContainer';
import TestHarness from './components/virtualBetSlip/TestHarness';
import { initializeUserStats } from "./userservices/userStats";
import { LanguageProvider } from './services/languageContext';
import { HelmetProvider } from 'react-helmet-async';
import { starCoinsClient } from './services/starCoinsClient';

// Routers
import EmailVerificationGuard from './components/emailVerification/EmailVerificationGuard';

// Gamification
import AchievementNotificationSystem from './components/gamification/AchievementNotificationSystem';

// Dev Tools - Auto-disabled in production (see App-dev-tester.js)
// import DevToolsContainer from './App-dev-tester';

// admin
import AdminPanel from './components/admin/AdminPanel';
// Specialty
import ScoreBoard from './services/ScoreBoard';
import { NavigationProvider } from './components/context/NavigationContext';
// import RewardNotifications from './userservices/RewardNotifications';

// pt-br
import PtBrHomePage from "./pages/main/PtBrHomePageNew";

// Brazilian Landing Pages
import BrasileiraoPage from "./seo-pages/brazilian-landing/BrasileiraoPage";
import LibertadoresPage from "./seo-pages/brazilian-landing/LibertadoresPage";
import CopaDoBrasilPage from "./seo-pages/brazilian-landing/CopaDoBrasilPage";
import EstaduaisPage from "./seo-pages/brazilian-landing/EstaduaisPage";
import CantosEscanteiosPage from "./seo-pages/brazilian-landing/CantosEscanteiosPage";
import FazerFezinhaPage from "./seo-pages/brazilian-landing/FazerFezinhaPage";
import TutorialAIFutebolPage from "./seo-pages/brazilian-landing/TutorialAIFutebolPage";

// Resource Pages (English)
import SportsBettingGuide from "./seo-pages/resources/SportsBettingGuide";
import AITechnology from "./seo-pages/resources/AITechnology";
import ResponsibleGaming from "./seo-pages/resources/ResponsibleGaming";
import AIX from "./seo-pages/resources/AIX/AIX";
import PickStarOnboarding from "./seo-pages/resources/pickstar-onboarding";
import AISportsBettingPicks from "./seo-pages/resources/AISportsBettingPicks";
import AIvsHumanPicks from "./seo-pages/resources/AIvsHumanPicks";

// Resource Pages (Portuguese)
import GuiaApostas from "./seo-pages/resources/pt-br/GuiaApostas";
import TecnologiaIA from "./seo-pages/resources/pt-br/TecnologiaIA";
import JogoResponsavel from "./seo-pages/resources/pt-br/JogoResponsavel";
import PalpitesIAPage from "./seo-pages/brazilian-landing/PalpitesIAPage";
import ComoUsarIAApostasPage from "./seo-pages/brazilian-landing/ComoUsarIAApostasPage";
import LibertadoresAIPicks2025Page from "./seo-pages/brazilian-landing/LibertadoresAIPicks2025Page";
import VolleyballDashboard from "./pages/sport-dashboards/volleyball/volleyballDashboard";
import {IsMobileProvider} from "./pages/sport-dashboards/volleyball/context/mobileContext";
import NHLDashboard from "./pages/sport-dashboards/NHL/nhlDashboard";
import NFLDashboard from "./pages/sport-dashboards/NFL/nflDashboard";
import NCAAFDashboard from "./pages/sport-dashboards/ncaaf/ncaafDashboard";
import {MMADashboard} from "./pages/sport-dashboards/mma";

// Sport Pages
import TennisPage from "./pages/sport-dashboards/tennis/TennisPage";


const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false); // Add this state to track auth check

  // FIXED: Add state to track processed users to prevent mounting loop
  const [processedUserUid, setProcessedUserUid] = useState(null);

  // FIXED: Memoize saveUserToFirestore to prevent unnecessary calls
  const saveUserToFirestore = useCallback(async (user) => {
    if (!user) return;

    try {
      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);

      if (!userDoc.exists()) {
        console.log('📝 Creating new user document for:', user.uid);
        await setDoc(userRef, {
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          tier: 'basic',
          emailVerified: user.emailVerified, // CHANGED: Track email verification instead of phone
          usage: {
            messageCount: 0,
            lastReset: serverTimestamp(),
            lastMessageTime: null
          }
        });
      } else {
        console.log('📝 Updating existing user document for:', user.uid);
        await setDoc(userRef, {
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          emailVerified: user.emailVerified, // CHANGED: Update email verification status
        }, { merge: true });
      }

      await initializeUserStats(user.uid);
      console.log("User data updated in Firestore!");
    } catch (error) {
      console.error("Error saving user: ", error);
    }
  }, []); // Empty dependency array since it doesn't depend on any state

  // Check for Stripe checkout return and verify purchase
  useEffect(() => {
    const checkPurchase = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('session_id')) {
        console.log('Detected Stripe return, verifying purchase...');
        await starCoinsClient.verifyAndProcessPurchase();
      }
    };
    checkPurchase();
  }, []);

  // In App.js
  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        // Fetch the main JS bundle to see if it's changed
        const response = await fetch(window.location.origin, {
          cache: 'no-cache',
          headers: { 'Cache-Control': 'no-cache' }
        });

        const html = await response.text();

        // Extract the current JS bundle hash from the HTML
        const currentBundleMatch = html.match(/\/static\/js\/main\.([a-f0-9]+)\.chunk\.js/);
        const currentBundle = currentBundleMatch ? currentBundleMatch[1] : null;

        // Store the original bundle hash on first load
        if (!window.__ORIGINAL_BUNDLE_HASH__) {
          window.__ORIGINAL_BUNDLE_HASH__ = currentBundle;
          return;
        }

        // If bundle hash changed, reload
        if (currentBundle && currentBundle !== window.__ORIGINAL_BUNDLE_HASH__) {
          console.log('New version detected, reloading...');
          window.location.reload();
        }
      } catch (error) {
        // Silently fail - don't want to break the app
        console.log('Update check failed:', error);
      }
    };

    // Check immediately, then every 5 minutes
    checkForUpdates();
    const interval = setInterval(checkForUpdates, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // FIXED: Update useEffect to prevent mounting loop by tracking processed users
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setAuthChecked(true); // Mark auth check as complete

      if (currentUser) {
        // Only process user data if this is a new/different user
        if (currentUser.uid !== processedUserUid) {
          console.log('🔧 Processing user data for:', currentUser.uid);
          setProcessedUserUid(currentUser.uid);

          await saveUserToFirestore(currentUser);
        } else {
          console.log('🔄 Skipping user data processing - already done for:', currentUser.uid);
        }
      } else {
        setProcessedUserUid(null); // Reset when user signs out
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [processedUserUid, saveUserToFirestore]); // Add dependencies to prevent stale closures

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <HelmetProvider>
      <PixelProvider>
        <IsMobileProvider>
        <Router>
          <LanguageProvider>
            <ChatProvider>
              <NavigationProvider>
                <div className="flex flex-col min-h-screen">

                  {process.env.REACT_APP_ENVIRONMENT === 'staging' && (
                    <div className="bg-yellow-500 text-black font-bold text-center py-1">
                      STAGING ENVIRONMENT
                    </div>
                  )}
                  <div className="flex-grow">
                    {user && <DropdownMenu user={user} />}

                    <Routes>
                      {/* Root route - redirect to appropriate page */}
                      <Route
                        path="/"
                        element={
                          authChecked ? (
                            user ? (
                              <Navigate to="/home" />
                            ) : (
                              <Navigate to="/home" />
                            )
                          ) : (
                            <LoadingScreen />
                          )
                        }
                      />

                      {/* Home route - show to all users, with auth prompts for features */}
                      <Route
                        path="/home"
                        element={
                          user ? (
                            <EmailVerificationGuard user={user}>
                              <HomePage user={user} />
                            </EmailVerificationGuard>
                          ) : (
                            <HomePage user={null} />
                          )
                        }
                      />

                      {/* Add a dedicated chat route */}
                      <Route
                        path="/chat"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-[#0A051E] to-emerald-900">
                              <ChatWindow
                                userId={user.uid}
                                user={user}
                                initialTransitionComplete={true}
                                startWithBlankChat={true}
                              />
                            </div>
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Public Landing Page - Preview Homepage */}
                      <Route
                        path="/arena"
                        element={<PreviewHomePage />}
                      />

                      {/* Other routes - protected ones redirect to login */}
                      <Route
                        path="/settings"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <Settings />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />
                      <Route
                        path="/upgrade"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <UpgradeToPro />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />
                      <Route
                        path="/help"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <HelpSupport />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />
                      <Route
                        path="/chat-history"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <ChatHistoryViewer userId={user.uid} />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Prediction Analytics route - protected */}
                      {/* TODO: Needs more development before production
                <Route
                  path="/analytics"
                  element={user ? <PredictionAnalytics /> : <Navigate to="/login" />}
                />
                */}

                      {/* Market Analytics route - protected */}
                      <Route
                        path="/market"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <MarketAnalytics />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Settlement Viewer route - admin only, development only */}
                      {(process.env.NODE_ENV === 'development' || process.env.REACT_APP_API_URL?.includes('localhost')) && (
                        <Route
                          path="/admin/settlements"
                          element={
                            user && (
                              user.email === 'rholt@pickstarai.com' ||
                              user.email === 'lucaas.sn@gmail.com' ||
                              user.email === 'ronaldsholt@gmail.com'
                            ) ? (
                              <SettlementViewer />
                            ) : (
                              <Navigate to="/" />
                            )
                          }
                        />
                      )}

                      {/* Prediction Accuracy Dashboard - admin only, development only */}
                      {(process.env.NODE_ENV === 'development' || process.env.REACT_APP_API_URL?.includes('localhost')) && (
                        <Route
                          path="/admin/predictions"
                          element={
                            user && (
                              user.email === 'rholt@pickstarai.com' ||
                              user.email === 'lucaas.sn@gmail.com' ||
                              user.email === 'ronaldsholt@gmail.com'
                            ) ? (
                              <PredictionAccuracyDashboard />
                            ) : (
                              <Navigate to="/" />
                            )
                          }
                        />
                      )}

                      {/* PickStar Predictions Viewer - admin only, development only */}
                      {(process.env.NODE_ENV === 'development' || process.env.REACT_APP_API_URL?.includes('localhost')) && (
                        <>
                          <Route
                            path="/admin/pickstar-predictions"
                            element={
                              user && (
                                user.email === 'rholt@pickstarai.com' ||
                                user.email === 'lucaas.sn@gmail.com' ||
                                user.email === 'ronaldsholt@gmail.com'
                              ) ? (
                                <PickstarPredictionsViewer />
                              ) : (
                                <Navigate to="/" />
                              )
                            }
                          />
                          <Route
                            path="/admin/pickstar-performance"
                            element={
                              user && (
                                user.email === 'rholt@pickstarai.com' ||
                                user.email === 'lucaas.sn@gmail.com' ||
                                user.email === 'ronaldsholt@gmail.com'
                              ) ? (
                                <PickstarPerformance />
                              ) : (
                                <Navigate to="/" />
                              )
                            }
                          />
                        </>
                      )}

                      {/* Sports Hub Main route - protected */}
                      <Route
                        path="/sports-hub"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <SportsHub />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />
                      {/* MMA Fights route - protected */}
                      <Route
                        path="/mma-fights"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <MMADashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />
                      <Route
                        path="/mma"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <MMADashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Football route - protected */}
                      <Route
                        path="/football"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <FootballDashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Volleyball route - protected */}
                      <Route
                        path="/volleyball"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <VolleyballDashboard/>
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* NFL route - protected */}
                      <Route
                        path="/nfl"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <NFLDashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* NHL route - protected */}
                      <Route
                        path="/nhl"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <NHLDashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* NBA route - protected */}
                      <Route
                        path="/nba"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <NBADashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* ncaa football route - protected */}
                      <Route
                        path="/ncaaf"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <NCAAFDashboard />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Baseball route - protected */}
                      <Route
                        path="/mlb"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <BaseballDashRefactored />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* F1 route - protected */}
                      <Route
                        path="/f1"
                        element={user ? (
                          <EmailVerificationGuard user={user}>
                            <F1Dash />
                          </EmailVerificationGuard>
                        ) : (
                          <Navigate to="/login" />
                        )}
                      />

                      {/* Public routes */}
                      <Route path="/about-us" element={<AboutUs />} />
                      <Route path="/pricing" element={<Pricing />} />
                      <Route path="/tennis" element={<TennisPage />} />

                      {/* Keep direct login route accessible - allow authenticated users who need email verification */}
                      <Route
                        path="/login"
                        element={!user ? <Login /> : <Navigate to="/home" />}
                      />
                      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/faq" element={<FAQ />} />

                      {/* pt br page */}
                      <Route path="/pt-br" element={<PtBrHomePage />} />

                      {/* Brazilian Landing Pages */}
                      <Route path="/pt-br/brasileirao" element={<BrasileiraoPage />} />
                      <Route path="/pt-br/libertadores" element={<LibertadoresPage />} />
                      <Route path="/pt-br/copa-do-brasil" element={<CopaDoBrasilPage />} />
                      <Route path="/pt-br/estaduais" element={<EstaduaisPage />} />
                      <Route path="/pt-br/cantos-escanteios" element={<CantosEscanteiosPage />} />

                      {/* NFL Resources */}
                      <Route path="/resources/nfl/2025/week1/power-rankings" element={<PowerRankings />} />
                      <Route path="/pt-br/fazer-fezinha" element={<FazerFezinhaPage />} />
                      <Route path="/pt-br/tutorial-ia-futebol" element={<TutorialAIFutebolPage />} />

                      {/* Resource Pages - English */}
                      <Route path="/guide" element={<SportsBettingGuide />} />
                      <Route path="/technology" element={<AITechnology />} />
                      <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
                      <Route path="/resources/aix" element={<AIX />} />
                      <Route path="/resources/pickstar-onboarding" element={<PickStarOnboarding />} />
                      <Route path="/ai-sports-betting-picks" element={<AISportsBettingPicks />} />
                      <Route path="/ai-vs-human-picks" element={<AIvsHumanPicks />} />

                      {/* Resource Pages - Portuguese */}
                      <Route path="/pt-br/guia" element={<GuiaApostas />} />
                      <Route path="/pt-br/tecnologia" element={<TecnologiaIA />} />
                      <Route path="/pt-br/jogo-responsavel" element={<JogoResponsavel />} />
                      <Route path="/palpites-ia" element={<PalpitesIAPage />} />
                      <Route path="/como-usar-ia-apostas-esportivas" element={<ComoUsarIAApostasPage />} />
                      <Route path="/libertadores-ai-picks-2025" element={<LibertadoresAIPicks2025Page />} />


                      {process.env.NODE_ENV === 'development' && (
                        <>
                          <Route
                            path="/dev/tests"
                            element={user ? <TestContainer /> : <Navigate to="/login" />}
                          />
                          <Route
                            path="/dev/chat"
                            element={
                              user ? (
                                <ChatWindow
                                  userId={user.uid}
                                  standalone={true}
                                />
                              ) : (
                                <Navigate to="/login" />
                              )
                            }
                          />
                          <Route
                            path="/test-odds"
                            element={<TestHarness />}
                          />
                        </>
                      )}

                      <Route
                        path="/scoreboard"
                        element={user ? <ScoreBoard teamAbbr="LAL" refreshInterval={5000} /> : <Navigate to="/login" />}
                      />

                      <Route
                        path="/admin"
                        element={
                          user?.email === 'rholt@pickstarai.com'
                            ? <AdminPanel user={user} />
                            : <Navigate to="/home" />
                        }
                      />
                    </Routes>

                    {auth.currentUser && (
                      <AchievementNotificationSystem userId={auth.currentUser.uid} />
                    )}
                  </div>
                  {/* <RewardNotifications userId={auth.currentUser.uid} /> */}

                  {/* Dev Tools - Auto-disabled in production */}
                  {/* <DevToolsContainer /> */}
                </div>
              </NavigationProvider>
            </ChatProvider>
          </LanguageProvider>
        </Router>
        </IsMobileProvider>
      </PixelProvider>
    </HelmetProvider>
  );
};

export default App;
